export const platforms = [
  {
    id: "bilibili",
    name: "哔哩哔哩（B站）",
    category: "zonghe",
    description: "中国年轻世代高度聚集的文化社区和视频平台，拥有海量正版影视资源、纪录片和动漫内容，支持高清1080P画质免费观看。",
    features: ["免费弹幕互动", "1080P高清", "海量纪录片", "原创内容", "社区氛围好"],
    rating: 4.8,
    imageUrl: "https://readdy.ai/api/search-image?query=Bilibili%20streaming%20platform%20interface%20with%20anime%20and%20movie%20thumbnails%2C%20clean%20modern%20UI%20design%2C%20warm%20pink%20and%20white%20color%20scheme%2C%20soft%20lighting%2C%20cinematic%20composition%2C%20editorial%20style%20with%20subtle%20gradients%20and%20minimalist%20layout&width=800&height=500&seq=bilibili-card&orientation=landscape",
    websiteUrl: "https://www.bilibili.com",
    articleSlug: "bilibili-mianfei-kanpian-tuijian"
  },
  {
    id: "youku",
    name: "优酷",
    category: "dianshiju",
    description: "阿里巴巴旗下视频平台，拥有大量正版电视剧、综艺节目和电影资源，免费专区内容丰富，支持高清流畅播放。",
    features: ["独播剧集", "高清画质", "热门综艺", "经典老片", "多端同步"],
    rating: 4.5,
    imageUrl: "https://readdy.ai/api/search-image?query=Youku%20video%20streaming%20platform%20homepage%20with%20drama%20and%20variety%20show%20thumbnails%2C%20clean%20modern%20interface%2C%20warm%20orange%20and%20white%20tones%2C%20professional%20product%20photography%2C%20minimalist%20design%20with%20cinematic%20feel&width=800&height=500&seq=youku-card&orientation=landscape",
    websiteUrl: "https://www.youku.com",
    articleSlug: "youku-mianfei-kanpian-tuijian"
  },
  {
    id: "iqiyi",
    name: "爱奇艺",
    category: "zonghe",
    description: "中国领先的视频娱乐服务平台，免费频道提供海量电影、电视剧、综艺和动漫资源，以流畅播放体验和丰富独家内容著称。",
    features: ["独家内容", "1080P+画质", "AI推荐", "多语言字幕", "离线缓存"],
    rating: 4.6,
    imageUrl: "https://readdy.ai/api/search-image?query=IQiyi%20streaming%20platform%20interface%20with%20movie%20and%20TV%20show%20thumbnails%2C%20modern%20green%20and%20white%20UI%20design%2C%20clean%20layout%2C%20soft%20ambient%20lighting%2C%20editorial%20product%20photography%2C%20minimalist%20composition&width=800&height=500&seq=iqiyi-card&orientation=landscape",
    websiteUrl: "https://www.iqiyi.com",
    articleSlug: "iqiyi-mianfei-kanpian-tuijian"
  },
  {
    id: "mgtv",
    name: "芒果TV",
    category: "zongyi",
    description: "湖南广播电视台旗下视频平台，以优质综艺节目和原创剧集见长，免费频道提供丰富多样的综艺、电视剧内容。",
    features: ["王牌综艺", "原创剧集", "卫视同步", "高清直播", "互动玩法"],
    rating: 4.4,
    imageUrl: "https://readdy.ai/api/search-image?query=Mango%20TV%20streaming%20platform%20interface%20showing%20variety%20shows%20and%20dramas%2C%20warm%20orange-yellow%20color%20scheme%2C%20modern%20clean%20UI%2C%20cinematic%20composition%2C%20product%20photography%20style%20with%20soft%20lighting&width=800&height=500&seq=mgtv-card&orientation=landscape",
    websiteUrl: "https://www.mgtv.com",
    articleSlug: "mgtv-mianfei-kanpian-tuijian"
  },
  {
    id: "yangshipin",
    name: "央视频",
    category: "dianshiju",
    description: "中央广播电视总台官方视频平台，提供央视及地方卫视高清直播和点播服务，所有内容均为正版免费，画质出色。",
    features: ["央视直播", "高清回放", "纪录片资源", "新闻资讯", "体育赛事"],
    rating: 4.7,
    imageUrl: "https://readdy.ai/api/search-image?query=CCTV%20Yangshipin%20official%20streaming%20platform%20interface%2C%20news%20and%20documentary%20thumbnails%2C%20clean%20professional%20design%2C%20red%20and%20white%20color%20scheme%2C%20modern%20UI%2C%20editorial%20product%20photography%20with%20cinematic%20lighting&width=800&height=500&seq=yangshipin-card&orientation=landscape",
    websiteUrl: "https://www.yangshipin.cn",
    articleSlug: "yangshipin-mianfei-kanpian-tuijian"
  },
  {
    id: "douyin",
    name: "抖音",
    category: "duanshipin",
    description: "全球领先的短视频平台，影视剪辑和短剧频道有大量免费影视解说、精彩片段和短剧内容，碎片时间追剧利器。",
    features: ["短剧频道", "影视解说", "短视频", "算法推荐", "碎片追剧"],
    rating: 4.3,
    imageUrl: "https://readdy.ai/api/search-image?query=Douyin%20short%20video%20platform%20interface%20with%20movie%20clips%20and%20entertainment%20content%2C%20modern%20dark%20UI%20design%2C%20vibrant%20and%20dynamic%20composition%2C%20product%20photography%20style%2C%20clean%20minimal%20layout&width=800&height=500&seq=douyin-card&orientation=landscape",
    websiteUrl: "https://www.douyin.com",
    articleSlug: "douyin-mianfei-kanpian-tuijian"
  },
  {
    id: "xigua",
    name: "西瓜视频",
    category: "dianying",
    description: "字节跳动旗下中视频平台，拥有海量免费电影、电视剧和纪录片资源，支持高清播放，内容丰富更新快。",
    features: ["免费大片", "中长视频", "高清画质", "个性化推荐", "创作者生态"],
    rating: 4.4,
    imageUrl: "https://readdy.ai/api/search-image?query=Xigua%20video%20streaming%20platform%20homepage%20with%20movie%20and%20TV%20thumbnails%2C%20modern%20clean%20interface%2C%20warm%20green%20and%20white%20color%20tones%2C%20cinematic%20product%20photography%2C%20minimalist%20design%20layout&width=800&height=500&seq=xigua-card&orientation=landscape",
    websiteUrl: "https://www.ixigua.com",
    articleSlug: "xigua-mianfei-kanpian-tuijian"
  },
  {
    id: "sohu",
    name: "搜狐视频",
    category: "dianshiju",
    description: "搜狐旗下老牌视频平台，美剧频道资源丰富，免费专区提供大量经典美剧、国产剧和电影，支持高清流畅播放。",
    features: ["美剧专区", "经典国剧", "高清画质", "稳定流畅", "大屏体验"],
    rating: 4.2,
    imageUrl: "https://readdy.ai/api/search-image?query=Sohu%20video%20streaming%20platform%20interface%20with%20drama%20and%20movie%20thumbnails%2C%20modern%20clean%20UI%20design%2C%20warm%20gray%20and%20white%20color%20scheme%2C%20professional%20product%20photography%2C%20minimalist%20composition&width=800&height=500&seq=sohu-card&orientation=landscape",
    websiteUrl: "https://tv.sohu.com",
    articleSlug: "sohu-mianfei-kanpian-tuijian"
  },
  {
    id: "cctv-doc",
    name: "央视纪录",
    category: "jilupian",
    description: "央视纪录频道官方平台，提供海量高质量纪录片免费观看，涵盖自然、历史、人文、科技等多个领域，画质出众。",
    features: ["正版纪录片", "4K画质", "专业知识", "多领域覆盖", "央视品质"],
    rating: 4.9,
    imageUrl: "https://readdy.ai/api/search-image?query=CCTV%20documentary%20channel%20streaming%20interface%20with%20nature%20and%20history%20documentary%20thumbnails%2C%20professional%20clean%20design%2C%20warm%20earth%20tones%2C%20cinematic%20product%20photography%2C%20elegant%20minimalist%20layout&width=800&height=500&seq=cctvdoc-card&orientation=landscape",
    websiteUrl: "https://tv.cctv.com",
    articleSlug: "cctv-doc-mianfei-kanpian-tuijian"
  },
  {
    id: "tencent",
    name: "腾讯视频",
    category: "zonghe",
    description: "腾讯旗下综合视频平台，免费频道提供海量影视综艺动漫内容，以大IP资源和独家自制内容为核心竞争力。",
    features: ["大IP资源", "自制内容", "动漫资源", "1080P画质", "多端同步"],
    rating: 4.5,
    imageUrl: "https://readdy.ai/api/search-image?query=Tencent%20video%20streaming%20platform%20homepage%20with%20movie%20and%20anime%20thumbnails%2C%20modern%20dark%20UI%20design%2C%20warm%20accent%20colors%2C%20cinematic%20product%20photography%2C%20clean%20minimalist%20composition&width=800&height=500&seq=tencent-card&orientation=landscape",
    websiteUrl: "https://v.qq.com",
    articleSlug: "tencent-mianfei-kanpian-tuijian"
  },
  {
    id: "kuaishou",
    name: "快手",
    category: "duanshipin",
    description: "国民级短视频平台，短剧频道和影视剪辑区有大量免费影视内容，以接地气的创作风格和丰富的题材取胜。",
    features: ["短剧频道", "影视解说", "直播追剧", "接地气内容", "算法推荐"],
    rating: 4.2,
    imageUrl: "https://readdy.ai/api/search-image?query=Kuaishou%20short%20video%20platform%20interface%20with%20movie%20clips%2C%20modern%20orange%20and%20white%20UI%2C%20vibrant%20dynamic%20composition%2C%20product%20photography%20style%2C%20clean%20layout%20with%20cinematic%20feel&width=800&height=500&seq=kuaishou-card&orientation=landscape",
    websiteUrl: "https://www.kuaishou.com",
    articleSlug: "kuaishou-mianfei-kanpian-tuijian"
  },
  {
    id: "pptv",
    name: "PP视频",
    category: "dianying",
    description: "苏宁旗下视频平台，体育赛事直播是最大特色，同时提供丰富的免费电影、电视剧和综艺资源，体育迷首选。",
    features: ["体育直播", "免费电影", "经典剧集", "高清画质", "赛事回放"],
    rating: 4.1,
    imageUrl: "https://readdy.ai/api/search-image?query=PPTV%20streaming%20platform%20interface%20with%20sports%20and%20movie%20thumbnails%2C%20modern%20blue-white%20UI%20design%2C%20clean%20professional%20layout%2C%20product%20photography%20style%2C%20cinematic%20composition&width=800&height=500&seq=pptv-card&orientation=landscape",
    websiteUrl: "https://www.pptv.com",
    articleSlug: "pptv-mianfei-kanpian-tuijian"
  }
];

export const featuredPlatformIds = ["bilibili", "yangshipin", "iqiyi", "cctv-doc", "youku", "mgtv"];